import { Global } from '@emotion/react';
import { MantineProvider } from '@mantine/core';
import { emotionTransform, MantineEmotionProvider } from '@mantine/emotion';
import type { ReactNode } from 'react';
import { mantineRootColorSchemeGlobalStyles, theme } from '../theme';

export const DesignSystemUi = ({
  children,
  forceColorScheme,
}: {
  children: ReactNode;
  forceColorScheme?: 'light' | 'dark' | 'auto';
}) => {
  // Only pass forceColorScheme to MantineProvider if it's not 'auto'
  const mantineForceColorScheme = forceColorScheme === 'auto' ? undefined : forceColorScheme;

  return (
    <MantineProvider
      theme={theme}
      forceColorScheme={mantineForceColorScheme}
      stylesTransform={emotionTransform}
      defaultColorScheme="auto"
    >
      <Global styles={mantineRootColorSchemeGlobalStyles} />
      <MantineEmotionProvider>{children}</MantineEmotionProvider>
    </MantineProvider>
  );
};
